import { NgModule } from "@angular/core";
import { CertificateCrudModule } from "../key/certificate";
import { PrivateKeyCrudModule } from "../key/private-key";
import { SharedModule } from "../shared";
import { AuthorityFormComponent } from "./authority-form.component";
import { AuthorityListComponent } from "./authority-list.component";
import { AuthorityRoutingModule } from "./authority-routing.module";
import { AuthorityService } from "./crud.service";
import { EndPointsComponent } from "./end-points.component";

const DIRECTIVES = [
	AuthorityFormComponent,
	AuthorityListComponent,
	EndPointsComponent,
];

@NgModule({
	imports: [
		SharedModule,
		AuthorityRoutingModule,
		PrivateKeyCrudModule,
		CertificateCrudModule,
	],
	providers: [AuthorityService],
	declarations: [...DIRECTIVES],
	exports: [...DIRECTIVES],
})
export class AuthorityCrudModule {}
